import C from "classnames";
import type { ElementProps } from "../types";
import S from "./Text.module.scss";

interface PlaintextProps extends ElementProps {
  textAbove?: boolean;
}

export const Plaintext = ({ template, innerRef, textAbove = false }: PlaintextProps) => {
  return (
    <div
      className={C(S.plainText, {
        [S.center as string]: template?.centered,
        [S.small as string]: template?.type === "smallText",
      })}
      contentEditable
      ref={(innerRef as React.RefObject<HTMLDivElement>) ?? undefined}
      dangerouslySetInnerHTML={{ __html: textAbove ? (template?.textAbove ?? "") : template?.text }}
    />
  );
};
